module.exports = __webpack_public_path__ + "static/img/bag.080df6a7.png";